import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { PhonePe } from "phonepesdk-web";
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
  user: any = {};
  duplicateEmailErrorMessage: any = '';
  duplicateEmailError: boolean = false
  duplicateMobileErrorMessage: any = '';
  duplicateMobileError: boolean = false
  customerId: number;
  ppavl: any;
  userDetails: any;
  response: any;
  responseUserDetails: any;
  isLoggedIn: boolean;

  constructor(private service: CommonHttpService, private http: HttpClient, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }

  ngOnInit() {

    let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
    if (localStorage.getItem("isLoggedin")) {
      this.isLoggedIn = true;
    }
    console.log(IsPhonepe);
    if (IsPhonepe == "phonepe") {
      this.ppavl = true;
    }
    let hasPopupShown = localStorage.getItem("hasPopupShown")
    console.log(hasPopupShown)
    if (this.ppavl == true && this.isLoggedIn == null && hasPopupShown != "true") {
      this.showPopupForPhonepeLogin()

    }
    window.scrollTo(0, 0)
    this.route.queryParams.subscribe(params => {
      this.user.ReferralId = Number(params['referralId'])
    });

    console.log(this.ppavl)
  }

  signup() {
    this.user.ReferralCode = null;
    this.user.CustomerGroupId = 5;
    this.user.LoginType = 'Normal';
    localStorage.setItem('signupDetails', JSON.stringify(this.user));

    this.router.navigate(['verify-otp']);



  }

  checkDuplicateEmail() {
    this.service.get(this.baseUrl + 'ESignUpAPI/IsEmailOrMobileNoAvailable/' + this.user.Email)
      .subscribe(
        data => {
          console.log(data)
          if (data != true) {
            this.duplicateEmailErrorMessage = data
            this.duplicateEmailError = true
          }
          else {
            this.duplicateEmailErrorMessage = ''
            this.duplicateEmailError = false;
          }

        },
        (error) => {
          this.loaderService.display(false);
        })
  }

  checkDuplicateMobile() {
    this.service.get(this.baseUrl + 'ESignUpAPI/IsEmailOrMobileNoAvailable/' + this.user.MobileNumber)
      .subscribe(
        data => {
          console.log(data)
          if (data != true) {
            this.duplicateMobileErrorMessage = data;
            this.duplicateMobileError = true;
          }
          else {
            this.duplicateMobileErrorMessage = '';
            this.duplicateMobileError = false;
          }

        },
        (error) => {
          this.loaderService.display(false);
        })
  }


  showPopupForPhonepeLogin() {
    PhonePe.PhonePe.build(PhonePe.Constants.Species.web).then((sdk) => {
      sdk
        .fetchAuthToken()
        .then((res) => {
          console.log(res);
          //   alert(res.grantToken)
          // console.log(JSON.stringify(res));
          // var str = '{"grantToken":"' + res.grantToken + '"}';
          // console.log(str);
          // var encodedData = window.btoa(str);
          // console.log(encodedData);
          // this.encodedBase64 = encodedData;
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   encodedData +
          //   "/v3/service/auth/access" +
          //   "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);


          this.fetchAccessToken(res.grantToken);
        })
        .catch((err) => {
          console.log(
            //{"error_code":"USER_SKIPPED","description":"User skipped"}
            "Error occurred while fetching the grant token: " + err
          );
          let error = JSON.parse(err);
          if (error.error_code == "USER_SKIPPED") {
            console.log("has popup shown set")
            localStorage.setItem("hasPopupShown", "true")

            //  this.router.navigate(["login"], { queryParams: { utm_source: 'phonepe' } });
          }
          //  alert(err);
        });
    });
  }
  fetchAccessToken(base64body) {
    //  var xVerifyHeader = hash + "###" + 1;
    //  console.log(xVerifyHeader);
    var myobj = {
      request: base64body,
      XVERIFY: "test",
    };
    console.log(myobj);
    this.loaderService.display(true);
    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeLoginAsync/", myobj)
      .subscribe(
        (data) => {
          this.response = data;
          console.log(this.response)

          this.loaderService.display(false);

          //   alert(this.response)
          // console.log(this.Response.data.accessToken);
          // let shaObj = new jsSHA("SHA-256", "TEXT");
          // shaObj.update(
          //   "/v3/service/userdetails" + "ee3c4a1c-a1b3-48c2-840a-b4b513b132d7"
          // );
          // let hash1 = shaObj.getHash("HEX");
          // var hash = hash1.toUpperCase();
          // console.log(hash1);
          // console.log(hash);
          // var xVerifyHeader = hash + "###" + 1;
          this.getUserDetails(this.response.data.accessToken);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);

        }
      );
  }
  getUserDetails(accessToken) {
    var userDetailobj = {
      request: accessToken,
      XVERIFY: "test",
    };
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/GetUserDetails/", userDetailobj)
      .subscribe(
        (data) => {
          console.log(data);
          this.responseUserDetails = data;
          this.loaderService.display(false);
          //data.name,data.phoneNumber
          console.log(this.responseUserDetails);
          this.postUserDetails(this.responseUserDetails);
        },
        (error: any) => {
          console.log(error);
          this.loaderService.display(false);

        }
      );
  }
  postUserDetails(userdetails) {
    var postData = {
      MobileNumber: userdetails.data.phoneNumber,
      Name: userdetails.data.name,
      LoginType: "Phonepe",
      Email: userdetails.data.email != undefined ? userdetails.data.email : "",
    };
    console.log(postData);
    this.loaderService.display(true);

    this.http
      .post(this.baseUrl + "LoginAPI/PhonepeSilentLogin/", postData)
      .subscribe(
        (data) => {
          this.userDetails = data;
          this.loaderService.display(false);

          if (this.userDetails.statusCode == 1) {
            localStorage.setItem("customerId", this.userDetails.customerId);
            localStorage.setItem("customerName", this.userDetails.customerName);
            localStorage.setItem("isLoggedin", "true");
            localStorage.setItem("customerMobile", this.userDetails.mobileNumber);

            console.log("login in now grocery via phone pe completed");
            window.location.href = ""
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/signup/signup.component.ts